module.exports = __webpack_public_path__ + "fontello.svg?86b6414dad9ee20a7d0d660ac4c01dfc";